module.exports = __webpack_public_path__ + "img/footer-image_320.6bd8e1c4.png";